export { default } from './ForgotPassword'


// WEBPACK FOOTER //
// ./src/scenes/ForgotPassword/index.js